import {
  ConstantOrderItemDeliverySpeed,
  ConstantOrderItemImageType,
  ConstantOrderItemRecurrence,
  OrderitemReadResponse,
  OrderitemUpdateOrderItemRequest
} from '@src/clients/clerk/api';
import { createOptimizedContext } from '@src/contexts/createOptimizedContext';
import { formatToUtcDate, getMinOrderDate } from '@src/utils';

export interface OrderParametersContext {
  values: OrderitemUpdateOrderItemRequest;
  errors: Partial<Record<keyof OrderitemReadResponse, string>>;
  hasUserCheckedFeasibility: boolean;
  response: OrderitemReadResponse;
  isAutoSaving: boolean;
}

export function getDefaultOrderParametersValues(): OrderitemUpdateOrderItemRequest {
  return {
    recurrence: ConstantOrderItemRecurrence['OrderItemRecurrenceOnce'],
    cloud_cover: 20,
    off_nadir: 20,
    bandset: { bandset_id: '' },
    usecase: 'agriculture',
    delivery_speed:
      ConstantOrderItemDeliverySpeed['OrderItemDeliverySpeedStandard'],
    images: [{ geometry: {} }],
    // start_date: formatToUtcDate(getMinOrderDate().toDate()),
    // end_date: formatToUtcDate(
    //   getMinOrderDate().add(2, 'days').add(1, 'month').toDate()
    // ),
    image_type: ConstantOrderItemImageType['OrderItemImageTypeVNIR'],
    payment_mode: 'FULL'
  };
}

export const {
  Provider: OrderParametersProvider,
  useStoreSelector: useOrderParametersSelector,
  useStoreDispatch: useOrderParametersDispatch,
  useStore: useOrderParametersStore
} = createOptimizedContext<OrderParametersContext>({
  values: getDefaultOrderParametersValues(),
  errors: {},
  hasUserCheckedFeasibility: false,
  response: {},
  isAutoSaving: false
});
